import { useEffect, useRef, useState } from 'react';
import { useApp } from '../store';

export function Header() {
  const status = useApp((s) => s.status);
  const openDialog = useApp((s) => s.openDialog);
  return (
    <header className="topbar">
      <div className="brand">
        <h1>Balansa aplis</h1>
        <p>Dzīves jomu līdzsvars un plūsmas starp tām</p>
      </div>
      <div className="actions">
        <span className={'status' + (status.err ? ' err' : '')} data-testid="status">
          {status.text}
        </span>
        <a className="btn" href="/api/export" download title="Datu kopija JSON formātā (saderīga ar HTML versiju)">
          Eksportēt
        </a>
        <button className="btn" type="button" onClick={() => openDialog({ kind: 'import' })} title="Ielādēt datus no HTML versijas faila vai JSON eksporta">
          Importēt
        </button>
        <button className="btn ghost" type="button" onClick={() => window.print()}>
          Drukāt
        </button>
        <UserMenu />
      </div>
    </header>
  );
}

function UserMenu() {
  const me = useApp((s) => s.me);
  const logout = useApp((s) => s.logout);
  const openDialog = useApp((s) => s.openDialog);
  const [open, setOpen] = useState(false);
  const [imgOk, setImgOk] = useState(true);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const onDown = (e: PointerEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('pointerdown', onDown);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('pointerdown', onDown);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  if (!me) return null;
  const initial = (me.name || me.email).trim().charAt(0).toUpperCase();
  return (
    <div className="umenu" ref={ref}>
      <button type="button" className="ubtn" aria-haspopup="menu" aria-expanded={open} onClick={() => setOpen(!open)} title={me.email} data-testid="user-menu">
        {me.avatarUrl && imgOk ? <img src={me.avatarUrl} alt="" referrerPolicy="no-referrer" onError={() => setImgOk(false)} /> : <span>{initial}</span>}
      </button>
      {open ? (
        <div className="upop card" role="menu">
          <div className="upop-h">
            <b>{me.name || 'Lietotājs'}</b>
            <small>{me.email}</small>
          </div>
          <button
            type="button"
            role="menuitem"
            className="upop-i"
            onClick={() => {
              setOpen(false);
              openDialog({ kind: 'profile' });
            }}
            data-testid="profile-menu"
          >
            Profils un drošība…
          </button>
          <button
            type="button"
            role="menuitem"
            className="upop-i"
            onClick={() => {
              setOpen(false);
              openDialog({ kind: 'mcp' });
            }}
            data-testid="mcp-menu"
          >
            MCP piekļuve (AI aģenti)…
          </button>
          <button type="button" role="menuitem" className="upop-i" onClick={() => void logout()} data-testid="logout">
            Iziet
          </button>
        </div>
      ) : null}
    </div>
  );
}
